import contractService from '@/service/contract/ContractService'

export default [{
  name: 'agreements',
  path: '/agreements',
  async beforeEnter(to, from, next) {
    if (window.DEBUG) {
      next()
      return
    }
    let isPending = await contractService.isPending()
    if (!isPending) {
      alert('이미 계약이 성공적으로 완료되었습니다.')
      next({ name: 'my' })
    } else {
      next()
    }
  },
  component: require('@/views/agreements/Agreements.vue').default
}, {
  name: 'agreements/detail',
  path: '/agreements/detail',
  component: require('@/views/agreements/AgreementsDetail.vue').default,
  props: (route) => ({ ...route.params })
}]
